import { useState, useEffect } from "react"
import { entries, keys, random, trunc, values } from "../../constants"
import { Effect } from "../../types"
import {Optional } from "../../types/optional"
import { optionalObject } from ".."

export const useRandom = (n: number = 10): number => {
    const [num, setNum] = useState<number>(n)
    useEffect((): Effect => {
        setNum(trunc(random() * n))
    }, [n])
    return num
}

export const useSlider = (bound: number): any[] => {
    const [num, setNum] = useState<number>(bound)

    const increment = (): void => setNum(num + 1)
    const decrement = (): void => setNum(num - 1)
    const reset = (): void => setNum(bound)

    useEffect((): Effect => {
        if (num > bound) setNum(0)
        if (num < 0) setNum(bound)
    }, [num, bound])
    return [num, { increment, decrement, reset }]
}

export const useUnwrapper = <T extends Object>(obj: Optional<T>) =>
({
    k: keys(optionalObject(obj)),
    v: values(optionalObject(obj)),
    e: entries(optionalObject(obj))
})

export const useToggle = (initialState: boolean = false) =>
{
    const [state, setState] = useState<boolean>(initialState)
    return {
        state, 
        toggle: (s: boolean): void => setState(s), 
        flip: () : void=> setState(!state),
        reset: (): void => setState(initialState)
    }
}
